export class ValidateSweetFaceManagerAccessPinRequestDto{
  // @IsNumber()
  // @ApiProperty({
  //   description: 'Pie Merchant ID',
  //   example: 7,
  // })
  pieMerchantId: number;

  // @IsString()
  // @ApiProperty({
  //   description: 'Manager Access Pin',
  //   maxLength: 6,
  //   minLength: 6,
  //   example: 456789,
  // })
  managerAccessPin: string;
}
